// imports
import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
// components
import CategorySelect from 'components/common/simpleSelectors/Category';
// interfaces, constants, helpers
import { CategorySelectorProps } from 'interfaces';

const CategorySelector: FC<CategorySelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <CategorySelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            error={Boolean(message)}
            helperText={message}
            {...rest}
          />
        );
      }}
    />
  );
};

export default CategorySelector;
